<script setup>
const {
    pillValues,
    align = 'left',
    leftIcon,
} = defineProps({
    pillValues: {
        type: Array,
        required: true,
    },
    align: {
        type: String,
        required: false,
    },
    leftIcon: {
        required: false,
        default: null,
    },
});
</script>

<template>
    <div
        class="relative inline-flex h-full items-center p-4"
        :class="{
            'justify-start': align === 'left',
            'justify-center text-center': align === 'center',
            'justify-end': align === 'right',
        }"
    >
        <div class="flex flex-wrap gap-2">
            <div
                v-for="(pill, pillIndex) in pillValues"
                :key="pillIndex"
                class="inline-flex items-center gap-1 rounded px-2 py-1 text-xs font-bold"
                :class="{
                    'bg-indigo-600 text-white': pill.type === 'primary',
                    'bg-gray-200 text-indigo-600': pill.type === 'secondary',
                    'bg-green-500 text-white': pill.type === 'success',
                    'bg-yellow-500 text-white': pill.type === 'warning',
                    'bg-red-500 text-white': pill.type === 'danger',
                }"
                :title="pill.title"
            >
                <component v-if="leftIcon" :is="leftIcon" class="size-5" />

                {{ pill.value }}
            </div>
        </div>
    </div>
</template>
